import { useQuery } from '@tanstack/react-query';

import { fetchUnreadCount } from '../services';

type UseUnreadCountOptions = {
  enabled?: boolean;
  grouped?: boolean;
};

export function useUnreadCount({ enabled = true, grouped = false }: UseUnreadCountOptions = {}) {
  return useQuery({
    queryKey: ['notifications', 'unread-count', grouped],
    queryFn: async () => {
      const data = await fetchUnreadCount(grouped);
      return data.count;
    },
    refetchInterval: 60_000,
    enabled,
  });
}
